/* ADA / WCAG fixes - MilkToast Brands (Oct 2026)
   Adds missing accessible names and hides decorative icons from screen readers. */
(function () {
  function hasName(el) {
    if (el.getAttribute('aria-label') && el.getAttribute('aria-label').trim()) return true;
    var lb = el.getAttribute('aria-labelledby');
    if (lb && lb.split(/\s+/).some(function (id) { return document.getElementById(id); })) return true;
    if (el.getAttribute('title') && el.getAttribute('title').trim()) return true;
    var txt = (el.innerText || el.textContent || '').trim();
    if (txt) return true;
    var imgs = el.querySelectorAll('img[alt]');
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].getAttribute('alt').trim()) return true; }
    return false;
  }

  function fix(root) {
    root = root || document;

    // 1. Decorative SVG icons: hide from screen readers unless they carry a name
    root.querySelectorAll('svg:not([aria-hidden])').forEach(function (s) {
      if (s.getAttribute('aria-label') || s.getAttribute('aria-labelledby') || s.querySelector('title')) {
        if (!s.getAttribute('role')) s.setAttribute('role', 'img');
        return;
      }
      s.setAttribute('aria-hidden', 'true');
      s.setAttribute('focusable', 'false');
    });

    // 2. Icon-only buttons with no name
    root.querySelectorAll('button, [role="button"]').forEach(function (b) {
      if (hasName(b)) return;
      var c = (b.className || '').toString();
      var label = 'Button';
      if (/close/i.test(c)) label = 'Close';
      else if (/prev/i.test(c)) label = 'Previous';
      else if (/next/i.test(c)) label = 'Next';
      else if (/cart/i.test(c)) label = 'Add to cart';
      else if (/search/i.test(c)) label = 'Search';
      else if (/menu|burger/i.test(c)) label = 'Menu';
      b.setAttribute('aria-label', label);
    });

    // 3. Icon-only links with no name
    root.querySelectorAll('a[href]').forEach(function (a) {
      if (hasName(a)) return;
      var h = a.getAttribute('href') || '';
      var label = '';
      if (/\/cart/.test(h)) label = 'Cart';
      else if (/\/account/.test(h)) label = 'Account';
      else if (/\/search/.test(h)) label = 'Search';
      else if (h === '/' || /^https?:\/\/[^/]*milktoastbrands\.com\/?$/.test(h)) label = 'MilkToast Brands home';
      else if (/instagram/i.test(h)) label = 'Instagram';
      else if (/tiktok/i.test(h)) label = 'TikTok';
      if (label) a.setAttribute('aria-label', label);
    });

    // 4. Menu dropdown chevrons (focusable divs) -> labelled buttons
    root.querySelectorAll('.dropdown-icon[tabindex]').forEach(function (d) {
      if (d.getAttribute('aria-label')) return;
      var item = d.closest('li');
      var link = item ? item.querySelector('a') : null;
      var name = link ? (link.innerText || link.textContent || '').trim() : '';
      d.setAttribute('role', 'button');
      d.setAttribute('aria-label', name ? 'Show ' + name + ' submenu' : 'Show submenu');
    });

    // 5. Filter swatches: labels with only a title (e.g. color filters)
    root.querySelectorAll('label[title]').forEach(function (l) {
      var t = l.getAttribute('title').trim();
      if (!t) return;
      if (!(l.textContent || '').trim() && !l.querySelector('.ada-sr-text')) {
        var s = document.createElement('span');
        s.className = 'visually-hidden ada-sr-text';
        s.textContent = t;
        l.appendChild(s);
      }
      var f = l.getAttribute('for') ? document.getElementById(l.getAttribute('for')) : l.querySelector('input');
      if (f) {
        var al = f.getAttribute('aria-label') || '';
        if (!al || /^filter\./.test(al)) f.setAttribute('aria-label', 'Filter: ' + t);
      }
    });

    // 6. Form fields with no label -> use placeholder / type
    root.querySelectorAll('input:not([type=hidden]):not([type=submit]):not([type=button]), select, textarea').forEach(function (f) {
      if (f.getAttribute('aria-label') || f.getAttribute('aria-labelledby')) return;
      if (f.id && document.querySelector('label[for="' + f.id + '"]')) {
        var l = document.querySelector('label[for="' + f.id + '"]');
        if ((l.textContent || '').trim() && l.getAttribute('aria-hidden') !== 'true') return;
      }
      if (f.closest('label') && (f.closest('label').textContent || '').trim()) return;
      var name = f.getAttribute('placeholder') || (f.type === 'email' ? 'Email' : f.type === 'search' ? 'Search' : f.name === 'sort_by' ? 'Sort by' : f.name || '');
      if (name) f.setAttribute('aria-label', name);
    });

    // 7. Broken aria-labelledby / aria-describedby references
    ['aria-labelledby', 'aria-describedby'].forEach(function (attr) {
      root.querySelectorAll('[' + attr + ']').forEach(function (el) {
        var ids = el.getAttribute(attr).split(/\s+/).filter(function (id) { return id && document.getElementById(id); });
        if (ids.length) el.setAttribute(attr, ids.join(' ')); else el.removeAttribute(attr);
      });
    });
  }

  function run() { try { fix(document); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 200); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
